<template>
  <span :class="{'has-padding-left-12':customStyle=='resume'}">
    <p
      class="title is-size-5 has-text-black has-text-left"
      :class="[customStyle=='resume' ? resumeClasses:projectClasses]"
      v-t="'collaboration_with'"
    ></p>
    <a :href="partnerURL">
      <img class="is-flex partner-logo" :src="logo" :class="{'has-padding-top-10':customStyle=='resume'}">
    </a>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['partnerLogo', 'partnerURL', 'customStyle'],
  mounted () {
    if (!this.partnerLogo) {
    }
    /* this.getCapsuleFiles({ data: { id: [this.partnerLogo[0].id] } }).then(
      rslt => {
        this.logo = rslt.data[0].fileUrl
      }
    ) */
  },
  data () {
    return {
      resumeClasses: ['is-marginless has-text-grey'],
      projectClasses: ['has-text-black']
    }
    // return { logo: '' }
  },
  methods: {
    ...mapActions(['getCapsuleFiles'])
  },
  computed: {
    logo: function () {
      return this.partnerLogo && this.partnerLogo[0].fileUrl
    }
  }
  /* watch: {
    partnerLogo: function (newLogo) {
      if (!newLogo) {
        return
      }
      this.getCapsuleFiles({ data: { id: [newLogo[0].id] } }).then(rslt => {
        this.logo = rslt.data[0].fileUrl
      })
    }
  } */
}
</script>

<style scoped>
.has-padding-top-10 {
  padding-top: 10px;
}
.has-padding-left-12 {
  padding-left: 12px;
}
</style>
